import axios from 'axios';
import dev from '../config/dev';

const axiosInstance = axios.create({
  baseURL: dev.BASE_URL,
  headers: { 'Content-Type': 'application/json'},
});
export default axiosInstance;
